'use client';
import { getSignedUrlFromThemeAction } from '@/serverActions/fileAction/getSignedUrlFromThemeAction';
import { getHostThemeByHostNameAction } from '@/serverActions/themeAction/queries/getHostThemeByHostNameAction';
import { setClientIdFromThemeAction } from '@/serverActions/themeAction/setClientIdFromThemeAction';
import { HostTheme } from '@/type/hostTheme';
import { createContext, useContext, useEffect, useState } from 'react';

type ThemeContextType = HostTheme | null;

const ThemeContext = createContext<ThemeContextType>(null);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState<HostTheme | null>(null);

  useEffect(() => {
    const loadTheme = async () => {
      // 1. ลองโหลดจาก localStorage ก่อน
      const storedTheme = localStorage.getItem('hostTheme');
      if (storedTheme) {
        try {
          console.log('Loading theme from localStorage');
          const parsed = JSON.parse(storedTheme);
          setTheme(parsed);

          // Ensure clientId cookie is set from the stored theme
          try {
            await setClientIdFromThemeAction(parsed);
          } catch (e) {
            console.warn('Failed to set clientId from stored theme', e);
          }

          return;
        } catch (e) {
          console.warn(
            'Theme in localStorage is corrupted. Fetching from API.',
          );
        }
      }

      // 2. ถ้าไม่มีหรือ parse ไม่ได้ → ดึงจาก API
      try {
        console.log("don't have theme in localStorage, fetching from API");
        const result = await getHostThemeByHostNameAction();
        setTheme(result);
        localStorage.setItem('hostTheme', JSON.stringify(result));

        return;
      } catch (error) {
        console.error('Error fetching theme from API:', error);
      }
    };

    loadTheme();
  }, []);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
